/**
 * Labstep
 *
 * @module components/Filter/Tag/Active
 * @desc Active tag filters
 */

import { onTagClear } from 'labstep-web/components/Filter/Tag/utils';
import { EntityReadEntityContainer } from 'labstep-web/containers/Entity/Read/Entity';
import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import { Tag } from 'labstep-web/models/tag.model';
import { LocationService } from 'labstep-web/services/location.service';
import type React from 'react';
import { withRouter } from 'react-router-dom';
import type { FilterTagActiveProps } from './types';

export const FilterTagActive: React.FC<FilterTagActiveProps> = ({
  searchParams,
  setParams,
  history,
  location,
}) => {
  if (!searchParams.tag_id) {
    return null;
  }
  return (
    <>
      {(searchParams.tag_id as string)
        .split(',')
        .map((id: string) => (
          <EntityReadEntityContainer
            key={id}
            entityName={Tag.entityName}
            id={id}
          >
            {({ entity: tag }) =>
              tag ? (
                <RemoveLabel
                  name={tag.name}
                  icon="tag"
                  status={{
                    isFetching: false,
                    error: null,
                  }}
                  onRemoveClick={() => {
                    onTagClear(tag.guid, searchParams, setParams);
                    LocationService.removeQueryParameter(
                      history,
                      location,
                      'tag_id',
                    );
                  }}
                />
              ) : null
            }
          </EntityReadEntityContainer>
        ))}
    </>
  );
};

export default withRouter(FilterTagActive);
